import classNames from 'classnames';
import React from 'react';
import {
	useSelector,
} from 'react-redux';

import {
	selectedSectionSelector,
} from '~/state/ui/selectors';

import useAutoExpandNavigation from '~/hooks/useAutoExpandNavigation';

import {
	type RenderProp,
	renderProp,
} from '~/utilities/renderProp';



type ChildProps = {
	isActive: boolean,
	isDimmed: boolean,
};

type Props = {
	children: RenderProp<ChildProps>,
	className?: string,
	onClick?: () => void,
	sectionName: string,
};

/**
 * Placeholder link component for dead links (Home, Content, Performance, Help, Integrations)
 * Prevents navigation but maintains the same interface as other navigation links
 */
const PlaceholderLink: React.FC<Props> = (props) => {
	const {
		children,
		className,
		onClick,
		sectionName,
	} = props;

	const selectedSection = useSelector(selectedSectionSelector);
	const handleAutoExpandNavigation = useAutoExpandNavigation();

	const isActive = selectedSection === sectionName;

	const handleClick = React.useCallback(
		(e: React.MouseEvent<HTMLAnchorElement>) => {
			e.preventDefault();

			// If we're in Phase 2 and new navigation is active, expand navigation to Phase 3
			handleAutoExpandNavigation();

			if (onClick) {
				onClick();
			}
		},
		[handleAutoExpandNavigation, onClick],
	);

	const finalClassName = classNames({
		'active': isActive,
	}, className);

	return (
		<a
			className={finalClassName}
			href="#"
			onClick={handleClick}
		>
			{renderProp(
				children,
				{
					isActive,
					isDimmed: false,
				},
			)}
		</a>
	);
};



export default PlaceholderLink;
